module.exports = __webpack_public_path__ + "img/icon_10.769dc92a.png";